import React from 'react'

import { Container } from '../../components/Bootstrap'
import { Bar } from '../../components/Charts'
import Footnote from '../../components/Footnote'
import Hero from '../../components/Hero'
import Layout from '../../components/Layout'
import Navigation from '../../components/Navigation'
import Summary from '../../components/Summary'

import { bold } from '../../styles'

const ConsumersTwo = () => (
  <Layout>
    <Hero>
      <h1>Question 2</h1>
      <p className={bold}>I have been involved with Centre for Independent Living Toronto (CILT) for:</p>
    </Hero>
    <Container>
      <Navigation prev="/consumers/1" next="/consumers/3" />
      <Bar
        data={{
          labels: [ 'Less than or equal to 1 year', 'Over 1 to 3 years', 'Over 3 to 5 years', 'Over 5 to 8 years', 'Over 8 to 10 years', 'Over 10 years', 'Other' ],
          series: [ [ 22, 6.5, 3.4, 3.3, 12, 52, 0 ] ]
        }}
        options={{
          axisY: {
            offset: 60,
            scaleMinSpace: 30,
          },
          height: '500px',
          width: '100%',
          high: 60,
          seriesBarDistance: 4
        }}
        caption="I have been involved with Centre for Independent Living Toronto (CILT) for"
      />
	  <Summary>The graph shows that the majority of respondents have been involved with CILT for more than 10 years.</Summary>
      <Footnote>
        Other includes not involved with CILT (0 years) and over 25 years
      </Footnote>
    </Container>
  </Layout>
)

export default ConsumersTwo
